module.exports = __webpack_public_path__ + "static/media/img_money_pack.20f3580b.png";